// store/glossarySlice.js
import { createSlice } from '@reduxjs/toolkit';
import { add } from 'lodash';

const glossarySlice = createSlice({
	name: 'glossary',
	initialState: [],
	reducers: {
		setGlossaryItems: (state, action) => {
			return action.payload;
		},
		addGlossaryEntry: (state, action) => {
			const newEntry = action.payload;

			const alreadyExists = state.some(
				(entry) =>
					entry.sourceLanguage === newEntry.sourceLanguage &&
					entry.sourceText.trim().toLowerCase() ===
						newEntry.sourceText.trim().toLowerCase() &&
					entry.targetLanguage === newEntry.targetLanguage &&
					entry.targetText.trim().toLowerCase() ===
						newEntry.targetText.trim().toLowerCase()
			);

			if (!alreadyExists) {
				state.push(newEntry);
			}
		},
		addGlossaryEntries: (state, action) => {
			const newEntries = action.payload;
			newEntries.forEach((entry) => {
				const alreadyExists = state.some(
					(existingEntry) =>
						existingEntry.sourceLanguage === entry.sourceLanguage &&
						existingEntry.sourceText.trim().toLowerCase() ===
							entry.sourceText.trim().toLowerCase() &&
						existingEntry.targetLanguage === entry.targetLanguage &&
						existingEntry.targetText.trim().toLowerCase() ===
							entry.targetText.trim().toLowerCase()
				);
				if (!alreadyExists) {
					state.push({ ...entry, _id: 'temp' });
				}
			});
		},
		updateGlossaryEntry: (state, action) => {
			const { index, updatedEntry } = action.payload;
			state[index] = updatedEntry;
		},
		deleteGlossaryEntry: (state, action) => {
			const { id } = action.payload;
			const index = state.findIndex((entry) => entry._id === id);
			if (index !== -1) {
				state.splice(index, 1);
			}
		},
		updateGlossaryId: (state, action) => {
			const { id, newId } = action.payload;
			const index = state.findIndex((entry) => entry._id === id);
			if (index !== -1) {
				state[index]._id = newId;
			}
		},
		updateGlossariesIds: (state, action) => {
			const updatedEntries = action.payload; // e.g., array of objects from API

			updatedEntries.forEach((updatedEntry) => {
				const index = state.findIndex(
					(entry) =>
						entry._id === 'temp' &&
						entry.sourceLanguage === updatedEntry.sourceLanguage &&
						entry.targetLanguage === updatedEntry.targetLanguage &&
						entry.sourceText.trim().toLowerCase() ===
							updatedEntry.sourceText.trim().toLowerCase() &&
						entry.targetText.trim().toLowerCase() ===
							updatedEntry.targetText.trim().toLowerCase()
				);
				if (index !== -1) {
					state[index]._id = updatedEntry._id;
				}
			});
		},
	},
});

export const {
	setGlossaryItems,
	addGlossaryEntry,
	updateGlossaryEntry,
	deleteGlossaryEntry,
	updateGlossaryId,
	addGlossaryEntries,
	updateGlossariesIds,
} = glossarySlice.actions;
export default glossarySlice.reducer;
